<template>
  <div class="animated fadeIn">
    Dashboard do Inpar
  </div>
</template>

<script>
export default {
  name: 'dashboard',
  components: {}
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }
</style>
